/*
  Quantity box extras (cart page + product page):
  1. When + or − is pressed the number slides up / down (like an odometer). Skipped for visitors
     who turned on "reduce motion". Only a moving copy of the number is animated, on top of the
     real input, so the value the cart uses is never delayed.
  2. On the cart page (<quantity-input data-remove-at-min>) the − button shows a bin at the
     minimum quantity; pressing it asks "Remove this item?" (#remove-item-modal in
     sections/cart-template.liquid) and on Yes clicks the line's normal remove button.
*/
(function () {
  var QTY = "input[name='quantity']";
  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function minOf(input) {
    var m = +input.min;
    return m > 0 ? m : 1;
  }

  function syncBin(box) {
    if (!box || !box.hasAttribute('data-remove-at-min')) return;
    var input = box.querySelector(QTY);
    var minus = box.querySelector('quantity-input-minus');
    if (!input || !minus) return;
    var atMin = +input.value <= minOf(input);
    if (atMin && !box.hasAttribute('data-at-min')) box._atMinSince = Date.now();
    box.toggleAttribute('data-at-min', atMin);
    var label = atMin ? box.getAttribute('data-remove-label') : minus.getAttribute('data-minus-label');
    if (label) minus.setAttribute('aria-label', label);
  }

  function roll(box, input, from, to) {
    if (from === to || isNaN(from) || isNaN(to)) return;
    if (reduceMotion && reduceMotion.matches) return;
    var prev = box.querySelector('.qty-roll');
    if (prev) prev.remove();
    var cs = getComputedStyle(input);
    var dir = to > from ? 'up' : 'down';
    var r = document.createElement('span');
    r.className = 'qty-roll';
    r.setAttribute('aria-hidden', 'true');
    r.style.left = input.offsetLeft + 'px';
    r.style.top = input.offsetTop + 'px';
    r.style.width = input.offsetWidth + 'px';
    r.style.height = input.offsetHeight + 'px';
    r.style.fontFamily = cs.fontFamily;
    r.style.fontSize = cs.fontSize;
    r.style.fontWeight = cs.fontWeight;
    r.style.color = cs.color;
    var out = document.createElement('span');
    var inn = document.createElement('span');
    out.className = 'qty-roll-out-' + dir;
    inn.className = 'qty-roll-in-' + dir;
    out.textContent = from;
    inn.textContent = to;
    r.appendChild(out);
    r.appendChild(inn);
    box.appendChild(r);
    box.classList.add('is-rolling');
    var done = function () {
      if (r.parentNode) r.remove();
      if (!box.querySelector('.qty-roll')) box.classList.remove('is-rolling');
    };
    inn.addEventListener('animationend', done);
    setTimeout(done, 600); /* safety net if the animation never reports back */
  }

  /* The cart can redraw its rows while the question is open, so the line is looked up again by its key on Yes. */
  var pendingKey = null, returnFocus = null;
  function modal() { return document.getElementById('remove-item-modal'); }
  function closeAsk() {
    var m = modal();
    if (m) m.classList.remove('is-open');
    pendingKey = null;
    if (returnFocus && document.contains(returnFocus)) returnFocus.focus({ preventScroll: true });
    returnFocus = null;
  }
  function askRemove(line, removeBtn, trigger) {
    var m = modal();
    if (!m) { removeBtn.click(); return; }
    pendingKey = line.getAttribute('data-key');
    returnFocus = trigger;
    var title = line.querySelector('.line-item_title');
    var name = m.querySelector('[data-remove-item-name]');
    if (name) name.textContent = title ? title.textContent.trim() : '';
    var img = m.querySelector('[data-remove-item-img]');
    var src = line.querySelector('.line-item_image img');
    var url = src && (src.currentSrc || src.src);
    if (img) {
      if (url && url.indexOf('data:') !== 0) { img.src = url; img.hidden = false; }
      else { img.removeAttribute('src'); img.hidden = true; }
    }
    m.classList.add('is-open');
    var yes = m.querySelector('[data-remove-yes]');
    if (yes) yes.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var m = modal();
    if (!m || !e.target.closest) return;
    if (e.target.closest('#remove-item-modal [data-close-remove]')) { closeAsk(); return; }
    if (e.target.closest('#remove-item-modal [data-remove-yes]')) {
      var key = pendingKey;
      returnFocus = null;
      closeAsk();
      var line = key && document.querySelector('cart-line-item[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
      var removeBtn = line && line.querySelector('.js-remove-btn');
      if (removeBtn) removeBtn.click();
    }
  });
  document.addEventListener('keydown', function (e) {
    var m = modal();
    if (e.key === 'Escape' && m && m.classList.contains('is-open')) closeAsk();
  });

  /* Capture phase: runs before the theme's own +/− handlers, so the old value is still in the box. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('quantity-input-minus, quantity-input-plus');
    if (!btn) return;
    var box = btn.closest('quantity-input');
    var input = box && box.querySelector(QTY);
    if (!input) return;

    if (btn.matches('quantity-input-minus') && box.hasAttribute('data-remove-at-min') && +input.value <= minOf(input)) {
      var line = box.closest('cart-line-item');
      var removeBtn = line && line.querySelector('.js-remove-btn');
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();
        /* a fast double-click on − (2 → 1 → bin) should not open the question by accident */
        if (Date.now() - (box._atMinSince || 0) < 400) return;
        askRemove(line, removeBtn, btn);
        return;
      }
    }

    var before = +input.value;
    setTimeout(function () {
      roll(box, input, before, +input.value);
      syncBin(box);
    }, 0);
  }, true);

  /* Typed numbers and every +/− change fire "input" on the box (not bubbling, so listen in capture). */
  ['input', 'change'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var t = e.target;
      if (t && t.matches && t.matches(QTY)) syncBin(t.closest('quantity-input'));
    }, true);
  });
})();
